import { useEffect, Fragment } from 'react';
import Breadcrumbs from '../../../sharedComponent/Breadcrumbs/Breadcrumbs'
import { useLazyQuery, useMutation } from '@apollo/client'
import { GET_TPV_LIST_WITH_MISSING_CONTRACTS, RETRIEVE_CONTRACTS } from '../../../../utils/GraphQLAPI'
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
const MySwal = withReactContent(Swal)
const ReInitiatePage = () => {

    const [fetchTpvList, { data }] = useLazyQuery(
        GET_TPV_LIST_WITH_MISSING_CONTRACTS,
        {
            fetchPolicy: 'network-only',
        }
    );


    const [retrieveContracts, { loading }] = useMutation(RETRIEVE_CONTRACTS);

    const { totalCount } = data?.getTpvListWithMissingContracts || { totalCount: 0, items: [] };
    const isButtonDisabled = totalCount <= 0 || loading;

    const handleFetch = async () => {
        try {
            const result = await MySwal.fire({
                icon: 'warning',
                title: 'ReInitiate Contracts',
                text: `This call will initiate 10 contracts per request.`,
                allowOutsideClick: false,
                allowEscapeKey: false,
                confirmButtonText: 'OK',
            })
            if (result.isConfirmed) {
                await retrieveContracts({
                    variables: {
                        clientId: [],
                    },
                });

                const options: any = {
                    customClass: {
                        popup: 'swal2-border-radius',
                    },
                    title: 'Contract initiated successfully',
                    icon: 'success',
                    confirmButtonColor: '#3E97FF',
                }
                MySwal.fire(options)
            }

        } catch (err) {
            console.error('Failed to fetch TPV list:', err);
        }

        finally {
            fetchTpvList();
        }

    };

    useEffect(() => {
        fetchTpvList();
    }, [fetchTpvList])

    return (
        <Fragment>
            <Breadcrumbs title="Monitor" subTitle="Home - Monitor List" />
            <h2 className="text-dark fs-3 fw-semibold mb-0">Re-Initiate Contract </h2>
            <section className="d-flex align-items-center justify-content-between mt-4 px-4 py-3 bg-light rounded shadow-sm">
                <h4 className="text-dark fs-3 fw-semibold mb-0">
                    Total Count: <span className="text-primary">{totalCount}</span>
                </h4>

                <button
                    className="btn btn-primary fw-semibold fs-6 d-flex align-items-center gap-2"
                    onClick={handleFetch}
                    disabled={isButtonDisabled}
                >
                    {loading && (
                        <span
                            className="spinner-border spinner-border-sm text-white"
                            role="status"
                            aria-hidden="true"
                        />
                    )}
                    {loading ? 'Loading...' : 'Re-Initiate Contract'}
                </button>
            </section>
        </Fragment>


    );
};

export default ReInitiatePage;
